import { apiPost } from '../../api'

export const add_learner_program = data => {
  return apiPost({
    endpoint: 'programs/link_user_program',
    data: data
  })
}
